import { Modal } from "../../../evo/bootstrap";
import { DndContext, closestCenter } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import { ArrowUpDown, GripVertical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ModalFooter, ModalHeader } from "@/components/admin/cards";
import SortableItem from "../SortableItem/index";

const OrderManageModal = ({ show, onHide, labelQuestions, handleDragEnd, saveSortedOrder, saving = false, changed = true }: any) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      backdrop="static"
      keyboard={false}
      aria-labelledby="orderModalTitle"
    >
      <ModalHeader
        icon={<ArrowUpDown />}
        title={<span id="orderModalTitle">Manage Menu Order</span>}
        description="Drag the key topics into the order you want. The chatbot shows them in this order, after the fixed menu buttons (booking, cancel, contact, agent)."
        onClose={onHide}
        closeDisabled={saving}
      />
      <Modal.Body>
        <div>
          <DndContext onDragEnd={handleDragEnd} collisionDetection={closestCenter}>
            <SortableContext
              items={labelQuestions.map(q => q.id)}
              strategy={verticalListSortingStrategy}
            >
              <ol data-evo-island className="flex flex-col gap-2 text-foreground" aria-label="Key topic order">
                {labelQuestions.map((item, index) => (
                  <li key={item.id}>
                    <SortableItem id={item.id}>
                      <div className="flex items-center gap-3 rounded-lg border border-border bg-card px-3 py-2 shadow-xs transition-colors hover:border-primary/40">
                        <GripVertical className="size-4 shrink-0 text-muted-foreground" aria-hidden="true" />
                        <span className="flex size-6 shrink-0 items-center justify-center rounded-full bg-primary/10 text-xs font-semibold text-primary">{index + 1}</span>
                        <span className="min-w-0 truncate text-sm font-medium">{item.mainQuestion || <em>(Untitled Menu)</em>}</span>
                      </div>
                    </SortableItem>
                  </li>
                ))}
              </ol>
            </SortableContext>
          </DndContext>
        </div>
      </Modal.Body>
      <ModalFooter>
        <Button type="button" variant="outline" size="sm" onClick={onHide} disabled={saving}>
          Close
        </Button>
        <Button type="button" size="sm" onClick={saveSortedOrder} disabled={saving || !changed}>
          {saving ? "Saving..." : "Save Order"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default OrderManageModal;
